import SearchBar from "components/base/SearchBar";
import { Select } from "components/base/Form";
import { useDebouncedCallback } from "use-debounce";
import { useSearchParams } from "react-router-dom";
import ReportsListTableView from "../final/ReportsListTableView";

const PAGE_SIZE = 30;

function PoQcReportListPage() {
  const [searchParams, setSearchParams] = useSearchParams({
    limit: PAGE_SIZE,
    offset: 0,
    q: "",
    status: "ALL",
    recentRange: "ONE_YEAR",
  });
  const limit = searchParams.get("limit");
  const offset = searchParams.get("offset");
  const q = searchParams.get("q");
  const status = searchParams.get("status");
  const parsedLimit = parseInt(limit);
  const parsedOffset = parseInt(offset);
  const reportLimit = Number.isFinite(parsedLimit) ? parsedLimit : PAGE_SIZE;
  const reportOffset = Number.isFinite(parsedOffset) ? parsedOffset : 0;
  const legacyRecentDays = searchParams.get("recentDays");
  const recentRange =
    searchParams.get("recentRange") ||
    (legacyRecentDays === "730" || legacyRecentDays === "ALL"
      ? "TWO_YEARS"
      : "ONE_YEAR");

  const params = {};
  searchParams.forEach((value, key) => {
    params[key] = value;
  });
  delete params.recentDays;

  const debounceSearch = useDebouncedCallback(
    (nextQ) => setSearchParams({ ...params, q: nextQ, offset: 0 }),
    500,
  );

  return (
    <div className="m-4 sm:mt-4 lg:m-6 flex flex-col flex-1">
      <div className="flex space-x-6 items-center">
        <div className="flex-1">
          <SearchBar
            placeholder="Search by product name, number, PO or factory."
            initialQuery={q}
            onChange={debounceSearch}
          />
        </div>
        <Select
          value={recentRange}
          onChange={(e) =>
            setSearchParams({
              ...params,
              recentRange: e.target.value,
              offset: 0,
            })
          }
        >
          <option value="ONE_YEAR">Past 1 year</option>
          <option value="TWO_YEARS">Past 2 years</option>
        </Select>
        <Select
          value={status}
          onChange={(e) =>
            setSearchParams({ ...params, status: e.target.value, offset: 0 })
          }
        >
          <option value="ALL">All Status</option>
          <option value="PENDING">Pending</option>
          <option value="PASS">Pass</option>
          <option value="FAIL">Fail</option>
        </Select>
      </div>

      <div className="mt-4 relative flex-1">
        <ReportsListTableView
          limit={reportLimit}
          offset={reportOffset}
          q={q}
          status={status === "ALL" ? null : status}
          recentRange={recentRange}
          sourceType="PO"
          setOffset={(nextOffset) =>
            setSearchParams({ ...params, offset: nextOffset })
          }
        />
      </div>
    </div>
  );
}

export default PoQcReportListPage;
